import { clsx } from "./auth-service-tools193.js";
import { getGlobalClassNames } from "./auth-service-tools197.js";
import { getOptionsClassNames } from "./auth-service-tools525.js";
import { getResolvedClassNames } from "./auth-service-tools526.js";
import { getRootClassName } from "./auth-service-tools527.js";
import { getSelectorClassName } from "./auth-service-tools528.js";
import { getStaticClassNames } from "./auth-service-tools529.js";
import { getThemeClassNames } from "./auth-service-tools530.js";
import { getVariantClassName } from "./auth-service-tools531.js";

function getClassName(_ref) {
  let {
    theme,
    options,
    themeName,
    selector,
    classNamesPrefix,
    classNames,
    classes,
    unstyled,
    className,
    rootSelector,
    props,
    stylesCtx,
    withStaticClasses,
    headless,
    transformedStyles
  } = _ref;
  return clsx(getGlobalClassNames({
    theme,
    options,
    unstyled: unstyled || headless
  }), getThemeClassNames({
    theme,
    themeName,
    selector,
    props,
    stylesCtx
  }), getVariantClassName({
    options,
    classes,
    selector,
    unstyled
  }), getResolvedClassNames({
    selector,
    stylesCtx,
    theme,
    classNames,
    props
  }), getResolvedClassNames({
    selector,
    stylesCtx,
    theme,
    classNames: transformedStyles,
    props
  }), getOptionsClassNames({
    selector,
    stylesCtx,
    options,
    props,
    theme
  }), getRootClassName({
    rootSelector,
    selector,
    className
  }), getSelectorClassName({
    selector,
    classes,
    unstyled: unstyled || headless
  }), withStaticClasses && !headless && getStaticClassNames({
    themeName,
    classNamesPrefix,
    selector,
    withStaticClass: options == null ? void 0 : options.withStaticClass
  }), options == null ? void 0 : options.className);
}

export { getClassName };